module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'dmihmiob',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
